module.exports = __webpack_public_path__ + "img/admin_adv_11.46972d14.png";